import { ChertoExperiments } from 'constants/experiments'
import { getChertoExperimentVariation } from './experimentSelectors'

type RecommendedRateInheritanceVariation = typeof ChertoExperiments.sppRecommendedRateInheritance.variations[number]

export function selectRecommendedRateInheritance(
  state: App.State,
): Exclude<RecommendedRateInheritanceVariation, 'control'> | undefined {
  const variation = getChertoExperimentVariation(state, ChertoExperiments.sppRecommendedRateInheritance)
  return variation === 'lpc' || variation === 'any' ? variation : undefined
}
